"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useFocus = function useFocus() {
  var htmlRef = _react.default.useRef(null);
  var setFocus = function setFocus() {
    return htmlRef.current && htmlRef.current.focus();
  };
  return [htmlRef, setFocus];
};
var _default = useFocus;
exports.default = _default;